import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import { ParticipantsFilterComponent } from '@/scopes/search/components/ParticipantsFilterComponent'
import { isLoadingSelector, participantsFilterSelector } from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function ParticipantsFilter({ onConfirm }: { onConfirm: (selection: RoomsParticipantDistribution) => void }) {
  const participantsOptions = useQuickSearchSelector(participantsFilterSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)

  return (
    <ParticipantsFilterComponent
      id="participants-filter"
      disabled={isLoading}
      defaultDistribution={participantsOptions}
      setSelection={onConfirm}
      biggerBreakpoint
      isMultiRoom
    />
  )
}
